import NavHeader from "../shared/Nav-Header";
import { useState, useEffect, useMemo } from "react";
import styles from './clubs.module.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Notification from '../shared/Notification';
import SocialMessageBox from '../shared/SocialMessageBox';
import defaultProfile2 from '../images/default-profile2.jpg';
import { CopyLinkIcon, LeaveGroupIcon, ReportIcon, DeleteIcon } from '../shared/icons/Icons';
import defaultClub1 from '../images/clubs/club-1.png'
import { useAuth } from '../context/AuthContext';
import { io } from 'socket.io-client';


const getSocketURL = () => {
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_API_URL || 'https://server-production-e45c.up.railway.app/';
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:5000';
};

const socket = io(getSocketURL(), { 
  transports: ['websocket', 'polling'],
  withCredentials: true,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000
});

const Clubs = () => {
    const { userId } = useAuth();
    const [showClubCreation, setShowClubCreation] = useState(false);
    const [notification, setNotification] = useState('');
    const [clubName, setClubName] = useState('');
    const [selectedNetworks, setSelectedNetworks] = useState([]);
    const [myClubs, setMyClubs] = useState([]);
    const [myActiveClubs, setMyActiveClubs] = useState([]);
    const [leftClubs, setLeftClubs] = useState([]);
    const [activeClubChat, setActiveClubChat] = useState(null);
    const [projectNetworkList, setProjectNetworkList] = useState([]);
    // const [name, setName] = useState('');
    // const [profilePicture, setProfilePicture] = useState('');
    const [reload, setReload] = useState(false);
    const [newClubCreated, setNewClubCreated] = useState(false);
    const [showOptions, setShowOptions] = useState(null);
    // const [leaveClubPopup, setLeaveClubPopup] = useState(false);
    const [reportClubPopup, setReportClubPopup] = useState(false);
    const [reportClubId, setReportClubId] = useState(null);
    const navigate = useNavigate();
    const [reportMessage, setReportMessage] = useState('');
    const [allClubs, setAllClubs] = useState([]);
    const newClubs = useMemo(() => {
        // console.log("newClubs:1",allClubs.filter(club => !myClubs.some(myClub => myClub._id === club._id)))
        return allClubs.filter(club => !myClubs.some(myClub => myClub._id === club._id));
    }, [allClubs, myClubs]);
    const [joinedClubs, setJoinedClubs] = useState([]); // Track joined clubs
    const joined = (clubId) => joinedClubs.includes(clubId);
    const token = useMemo(() => localStorage.getItem('token'), []);
    const socialType = 'club';

    const fetchData = async () => {
        try {
            if (!token) {
                localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
                navigate('/login');
                return;
            }
            const response = await axios.get('/api/pn/my-networks', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            // console.log("my-networks", response.data);
            const projectNetworkList = response.data;
            setProjectNetworkList(projectNetworkList);
            // console.log('Profile Picture:', profilePicture);
            // console.log('Project Network List:', projectNetworkList);
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Error fetching project networks data';
            // console.error(errorMessage);
            setNotification('Error fetching project networks data. Please try again.');
        }
    };


    useEffect(() => {
        if (!token) {
            localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
            navigate('/login');
            return;
        }
        
        const message = localStorage.getItem('notification');
        if (message) {
            setNotification(message);
            localStorage.removeItem('notification');
            }
    }, [navigate]);


    useEffect(() => {
        const fetchClubs = async ()=> {
            try {
                const response = await axios.get('/api/club/my-clubs', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setMyClubs(response.data.clubs);
                // console.log('response.data.', response.data);
                // console.log('response.data.applicant:', response.data.applicant);
                // console.log('response.data.clubs:', response.data.clubs);
                
                // console.log('response.data.clubs:', response.data.clubs.map(g => g.membership));
                // setMyActiveClubs(response.data.clubs.filter(club =>club.membership === 'member'));
            } catch (error) {
                console.error('Error fetching user clubs:', error);
            }
        }
        fetchClubs();

        const newClubs = async ()=> {
            try {
                const response = await axios.get('/api/club/all-clubs', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setAllClubs(response.data.clubs);
                // setJoinedClubs(response.data.clubs); // Set joined clubs
                // console.log('response.data.', response.data);
            } catch (error) {
                console.error('Error fetching all clubs:', error);
            }
        }
        newClubs();
        

    }, []);
    useEffect(() => {
        const handleClubSort = ({ socialId, createdAt }) => {
            setMyClubs(prev => {
                // Check if Club exists
                const clubExists = prev.some(g => g._id === socialId);
                if (!clubExists) return prev;

                // Update and sort
                return [...prev]
                    .map(g =>
                        g._id === socialId
                            ? { ...g, lastMessageCreatedAt: createdAt }
                            : g
                    )
                    .sort((a, b) => {
                        const dateA = new Date(a.lastMessageCreatedAt || 0);
                        const dateB = new Date(b.lastMessageCreatedAt || 0);
                        return dateB - dateA; // Descending order (latest first)
                    });
            });
        };

        socket.on('clubLastMessageUpdate', handleClubSort);
        return () => socket.off('clubLastMessageUpdate', handleClubSort);
    }, []);

    // useEffect(() => {
    //     setLeftClubs(myClubs.filter(club =>club.membership === 'left'));
    //     console.log('Active Clubs:', myActiveClubs);
    //     console.log('Left Clubs:', leftClubs);
    // }, [myClubs]);

    const handleShowClubCreation = () => {
        fetchData();
        if(showClubCreation) {
            setShowClubCreation(false);
        } else {
            setShowClubCreation(true);
        }
    };

    const handleCreateClub = async () => {

        try {
            const response = await axios.post('/api/club/create-club', {
                clubName,
                userIds: selectedNetworks
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.success) {
                setClubName('');
                setSelectedNetworks([]);
                setShowClubCreation(false);
                setTimeout(() => setNewClubCreated(true), 0);
                setNotification(response.data.message || 'Club created successfully!');
            }
        } catch (error) {
            console.error('Error creating club:', error.message);
            const errorMessage = error.response?.data?.message || 'Error creating club. Please try again.';
            setNotification(errorMessage);
        }
    };

     const handleSelectNetwork = async (event, networkId) => {
        event.stopPropagation();
        setSelectedNetworks((prevSelected) => {
            if (prevSelected.includes(networkId)) {
                return prevSelected.filter(id => id !== networkId);
            } else {
                return [...prevSelected, networkId];
            }
        });
    };

    const handleJoinClub = async (e, clubId) => {
        e.preventDefault();
        e.stopPropagation();
            try {
                const response = await axios.post('/api/club/join-club-home', {
                    clubId,
                }, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (response.data.success) {
                    setNotification(response.data.message || 'Joined Club successfully!');
                    setJoinedClubs(prevJoinedClubs => [...prevJoinedClubs, clubId]); // Update applied jobs
                }
            } catch (error) {
                // console.error('Error joining club:', error);
                const errorMessage = error.response?.data?.message || 'Error joining club. Please try again.';
                setNotification(errorMessage);
            }
    };

    const handleLeaveClub = async (e, clubId) => {
        e.preventDefault();
        e.stopPropagation();
        try {
            const response = await axios.post('/api/club/leave-club', {
                clubId,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.success) {
                setNotification(response.data.message || 'Club Left successfully!');
                setNotification( 'Club Left successfully!');
            }
        } catch (error) {
            // console.error('Error leaving club:', error);
            const errorMessage = error.response?.data?.message || 'Error leaving club. Please try again.';
            setNotification(errorMessage);
        }
    };

    const handleDeleteClub = async (clubId) => {
        try {
            const response = await axios.post('/api/club/delete-club', {
                clubId,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.success) {
                setNotification(response.data.message || 'Club Deleted successfully!');
            }
        } catch (error) {
            console.error('Error leaving club:', error.message);
            const errorMessage = error.response?.data?.message || 'Error deleting club. Please try again.';
            setNotification(errorMessage);
        }
    };

    const handleCopyInviteLink = async (e, clubId) => {
        e.preventDefault();
        e.stopPropagation();
        try {
            const response = await axios.post('/api/club/invite-link', 
                { clubId },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data.success) {
                const inviteLink = response.data.inviteLink;
                
                await navigator.clipboard.writeText(inviteLink);
                
                const expiresAt = new Date(response.data.expiresAt);
                const now = new Date();
                const daysLeft = Math.ceil((expiresAt - now) / (1000 * 60 * 60 * 24));
                
                setNotification(`Invite link copied to clipboard! Valid for ${daysLeft} days.`);
            }
        } catch (err) {
            console.error('Error generating invite link:', err.message);
            setNotification(err.response?.data?.message || 'Failed to generate invite link. Please try again.');
        }
    };

    const handleReportClub = async (e, clubId) => {
        e.preventDefault();
        e.stopPropagation();            
        try{
            await axios.post('/api/club/report-club', {
                clubId: clubId,
                reportMessage: reportMessage
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setReportClubPopup(false);
            setNotification('Club reported. Our team will review it shortly.');
        }
        catch (error) {
            // console.error('Error reporting club:', error.message);
            const errorMessage = error.response?.data?.message || 'Error reporting club. Please try again.';
            setNotification(errorMessage);
        }
        
    }
    const handleReportClubPopup = (clubId) => {
        setReportClubPopup(true);
        setReportClubId(clubId);
    };
    const cancelReportClub = () => {
        setReportClubPopup(false);
    };

    const handleClubClick = async (event, club) => {
        event.stopPropagation();
        event.preventDefault();
        navigate(`/club/${club._id}`
            ,{ state: { userId: userId } });
    };
    const handleClubChatClick = async (event, club) => {
        event.stopPropagation();
        setActiveClubChat(club);
    };

     const handleCloseChat = () => {
        setActiveClubChat(null);
    };
    const handleCloseNotification = () => {
        setNotification('');
    };

    const handleClubOptions = (event, index) => {
        event.stopPropagation();
        if (showOptions === index) {
            setShowOptions(null);
        } else {
            setShowOptions(index);
        }
    };

    const handleClickOutside = (event) => {
        if (!event.target.closest(`.${styles.threeDotsButton}`) && !event.target.closest(`.${styles.messageOptionsMenu}`)) {
            setShowOptions(null);
        }
    };
    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleProfileClick = async (event, networkId) => {
        event.stopPropagation();
        const profileStatus = 'friends';
        // console.log("profileStatus:hp", profileStatus);
        navigate(`/profile/${networkId}`, { state: profileStatus });  
    };
    return (
        <div>
            <NavHeader />
            {notification && (
                <Notification message={notification} onClose={handleCloseNotification} />
            )}
            <br/><br/>
            <br/><br/>
             <br/>
            {/* <h1>Club</h1> */}

             {/* {(!myActiveClubs || myActiveClubs.length !== 0) && (
                <>
                <div className={`${styles.myClubsSection} ${styles.pnClub}`}>
                    {(!myClubs || myClubs.length !== 0) && (
                        <>
                        <h3>👥Active Clubs👥 ({myActiveClubs.length})</h3>
                        <p className={styles.sectionSubtext}>Calling Features Soon!</p>
                        <ul>
                            <div className={styles.clubBox}>
                                <div className={styles.clubContainer}>
                                    {myActiveClubs?.map((club, index) => (
                                        <div  className={styles.clubItem}>
                                            <li key={club._id} onClick={(e) => handleClubClick(e, club)}>
                                                <div className={styles.clubContent}></div>
                                                <img title={club.name} src={club.profilePicture ? club.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultClub1}alt="pfp" className={styles.networkProfilePicture} />
                                                    <span className={styles.clubName}>🌟 {club.name} 🌟</span>
                                                    <span className={styles.clubMembers}>{club.participantCount} members</span>
                                                    <button 
                                                        className={styles.threeDotsButton} 
                                                        onClick={(e) => {handleClubOptions(e, showOptions === index ? null : index)}} title="options"
                                                    >
                                                        ⋮
                                                    </button>
                                                    <div className={styles.clubActivity}>
                                                        <span className={styles.activityIndicator}>💚 Active now!</span>
                                                        <span className={styles.activityIndicator} onClick={(e) => handleClubChatClick(e, club)}>💚 Chat📃</span>
                                                    </div>
                                            </li>
                                            {showOptions === index && (
                                                <div className={styles.messageOptionsMenu}>
                                                    <button 
                                                    onClick={(e) => 
                                                    {handleCopyInviteLink(e, club._id);setShowOptions(null)}}>
                                                        <CopyLinkIcon/>
                                                        Copy Invite Link
                                                    </button>
                                                    <button 
                                                    onClick={(e) => 
                                                    {handleLeaveClub(e, club._id);setShowOptions(null)}}>
                                                        <LeaveGroupIcon/>
                                                        Leave Club
                                                    </button>
                                                    <button 
                                                    onClick={(e) => {handleReportClubPopup(club._id);setShowOptions(null)}}>
                                                        <ReportIcon/>
                                                        Report Club
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </ul>
                        </>
                        )}

                    {(!leftClubs || leftClubs.length !== 0) && (
                    <>
                    <h3>Left Clubs👥 ({leftClubs.length})</h3>
                    <p className={styles.sectionSubtext}>Calling Features Soon!</p>
                    <ul>
                        <div className={styles.clubBox}>
                            <div className={styles.clubContainer}>
                                {leftClubs?.map((club, index) => (
                                    <div  className={styles.clubItem}>
                                        <li key={club._id} onClick={(e) => handleClubClick(e, club)}>
                                            <div className={styles.clubContent}></div>
                                            <img title={club.name} src={club.profilePicture ? club.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultClub1}alt="pfp" className={styles.networkProfilePicture} />
                                                <span className={styles.clubName}>🌟 {club.name} 🌟</span>
                                                <span className={styles.clubMembers}>{club.participantCount} members</span>
                                                <button 
                                                    className={styles.threeDotsButton} 
                                                    onClick={(e) => {handleClubOptions(e, showOptions === index ? null : index)}} title="options"
                                                >
                                                    ⋮
                                                </button>
                                                <div className={styles.clubActivity}>
                                                    <span className={styles.activityIndicator}>💚 Active now!</span>
                                                    <span className={styles.activityIndicator} onClick={(e) => handleClubChatClick(e, club)}>💚 Chat📃</span>
                                                </div>
                                        </li>
                                        {showOptions === index && (
                                            <div className={styles.messageOptionsMenu}>
                                                <button 
                                                onClick={(e) => 
                                                {handleCopyInviteLink(e, club._id);setShowOptions(null)}}>
                                                    <CopyLinkIcon/>
                                                    Copy Invite Link
                                                </button>
                                                <button 
                                                onClick={(e) => 
                                                {handleLeaveClub(e, club._id);setShowOptions(null)}}>
                                                    <LeaveGroupIcon/>
                                                    Leave Club
                                                </button>
                                                <button 
                                                onClick={(e) => {handleReportClubPopup(club._id);setShowOptions(null)}}>
                                                    <ReportIcon/>
                                                    Report Club
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </ul>
                    </>
                )}
                </div>
                </>
            )}
             */}
            {(!myClubs || myClubs.length !== 0) && (
                <div className={`${styles.myClubsSection} ${styles.pnClub}`}>
                        <h3>👥Active Clubs👥 ({myClubs.length})</h3>
                        <p className={styles.sectionSubtext}>Calling Features Soon!</p>
                        <ul>
                            <div className={styles.clubBox}>
                                <div className={styles.clubContainer}>
                                    {myClubs?.map((club, index) => (
                                        <div  className={styles.clubItem}>
                                            <li key={club._id} onClick={(e) => handleClubClick(e, club)}>
                                                <div className={styles.clubContent}></div>
                                                <img title={club.name} src={club.profilePicture ? club.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultClub1}alt="pfp" className={styles.networkProfilePicture} />
                                                    <span className={styles.clubName}>🌟 {club.name} 🌟</span>
                                                    <span className={styles.clubMembers}>{club.participantCount} members</span>
                                                    <button 
                                                        className={styles.threeDotsButton} 
                                                        onClick={(e) => {handleClubOptions(e, showOptions === index ? null : index)}} title="options"
                                                    >
                                                        ⋮
                                                    </button>
                                                    <div className={styles.clubActivity}>
                                                        <span className={styles.activityIndicator}>💚 Active now!</span>
                                                        <span className={styles.activityIndicator} onClick={(e) => handleClubChatClick(e, club)}>💚 Chat📃</span>
                                                    </div>
                                            </li>
                                            {showOptions === index && (
                                                <div className={styles.messageOptionsMenu}>
                                                    <button 
                                                    onClick={(e) => 
                                                    {handleCopyInviteLink(e, club._id);setShowOptions(null)}}>
                                                        <CopyLinkIcon/>
                                                        Copy Invite Link
                                                    </button>

                                                    {club.membership==='member' && <button 
                                                        onClick={(e) => 
                                                        {handleLeaveClub(e, club._id);setShowOptions(null)}}>
                                                            <LeaveGroupIcon/>
                                                            Leave Club
                                                        </button>
                                                    }
                                                    {club.membership==='left' && <button 
                                                        onClick={() => 
                                                        {handleDeleteClub(club._id);setShowOptions(null)}}>
                                                            <DeleteIcon/>
                                                            Delete Club
                                                        </button>
                                                    }
                                                    <button 
                                                    onClick={(e) => {handleReportClubPopup(club._id);setShowOptions(null)}}>
                                                        <ReportIcon/>
                                                        Report Club
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </ul>
                </div>
            )}
            <div className={`${styles.createClubSection} ${styles.pnClub}`}>
                <h3>Create Club!</h3>
                <p className={styles.sectionSubtext}>Bring Friends together</p>
                {!showClubCreation && <button onClick={handleShowClubCreation} className={styles.primaryAction}>
                    Create New Club
                </button>}
            </div>

            {showClubCreation && (
                <div className={styles.mainContent}>
                    <div className={styles.leftColumn}>
                        <div className={styles.clubCreationForm}>
                            <h4>🌈 Give Your Club a Special Name 🌈</h4>
                            <input
                                type="text"
                                value={clubName}
                                onChange={(e) => setClubName(e.target.value)}
                                placeholder="Set Club Name"
                                className={styles.clubNameInput}
                            />
                            <button onClick={handleCreateClub} className={styles.createButton}>
                                🎊 Create Club! 🎊
                            </button>
                            <button onClick={handleShowClubCreation} className={styles.closeCreateClubButton}>
                                Cancel
                            </button>
                        </div>
                    </div>
                    <div className={styles.rightColumn}>
                        {(projectNetworkList || projectNetworkList.length !== 0) &&  (
                            <div className={`${styles.networksSection} ${styles.pnClub}`}>
                                <h3>Add Friends</h3>
                                <ul>
                                    {projectNetworkList?.map(network => (
                                        <li key={network._id} className={styles.networkItem} 
                                        onClick={(e) => handleSelectNetwork(e, network._id)}
                                        >
                                            <div className={styles.networkInfo} >
                                                <img title={network.name} src={network.profilePicture ? network.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile2}alt="pfp" className={styles.networkProfilePicture} />
                                                <span className={styles.networkName}>💫 {network.name} 💫</span>
                                                <span className={styles.connectionTime}>{network.skills}</span>
                                                <input type="checkbox" checked={selectedNetworks.includes(network._id)}/>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                                {(!projectNetworkList || projectNetworkList.length === 0) && (
                                <div className={styles.emptyState}>
                                    <p>🥺 No connections yet? Let's find some amazing people to connect with! 🥺</p>
                                </div> 
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}
            {reportClubPopup && (
                <div className={styles.popupOverlay}>
                    <div className={styles.popupContent}>
                        <h2>Reporting Club</h2>
                        <p>Thanks, Reported Club are reviewed shortly.</p>
                            <textArea
                                type="text"
                                value={reportMessage}
                                onChange={(e) => setReportMessage(e.target.value)}
                                placeholder="Report Message (Optional)"
                                className={styles.reportMessageInput}
                            />
                        <div className={styles.popupActions}>
                            <button onClick={(e)=>handleReportClub(e, reportClubId)} className={styles.confirmButton}>Report</button>
                            <button onClick={cancelReportClub} className={styles.cancelButton}>Cancel</button>
                        </div>
                    </div>
                </div>
            )}
            {(!newClubs || newClubs.length != 0) && (
                <div className={`${styles.myClubsSection} ${styles.pnClub}`}>
                    <h2>👥New Clubs👥 ({newClubs.length})</h2>
                    <ul>
                    <div className={styles.clubBox}>
                        <div className={styles.clubContainer}>
                            {newClubs?.map((club, index) => (
                                <div  className={styles.clubItem}>
                                    <li key={club._id} onClick={(e) => handleClubClick(e, club)}>
                                    <div className={styles.clubContent}>
                                        <img title={club.name} src={club.profilePicture ? club.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultClub1}alt="pfp" className={styles.networkProfilePicture} />
                                        <span className={styles.clubName}>🌟 {club.name} 🌟</span>
                                        <span className={styles.clubMembers}>{club.participantCount} members</span>
                                            <div className={styles.clubActivity}>
                                            <span className={styles.activityIndicator}>
                                                <button
                                                    className={`${styles.joinButton} ${joined(club._id) ? styles.joined : ''}`}
                                                    onClick={(e) => handleJoinClub(e, club._id)}
                                                    disabled={joined(club._id)}
                                                >
                                                    {joined(club._id) ? (
                                                        <>
                                                            <span className={styles.checkIcon}>✓</span>
                                                            Joined
                                                        </>
                                                    ) : (
                                                        '💚 Join Club'
                                                    )}
                                                </button>
                                                </span>
                                            </div>
                                    </div>
                                    </li>
                                </div>
                            ))}
                        </div>
                    </div>
                    </ul>
                </div>
            )}
            {activeClubChat && (
                <SocialMessageBox socialType={socialType} social={activeClubChat} onClose={handleCloseChat} /> 
            )}
        </div>
    );
}
export default Clubs;